import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { Button } from 'foundations-components/transitional/components/Button';
import { H5 } from 'foundations-components/transitional/components/H5';
import { H1 } from 'foundations-components/transitional/components/H1';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuizEndScreen = ({
  onRetakeClick,
  totalQuestions,
  correctAnswers
}) => /*#__PURE__*/_jsx(Flex, {
  alignItems: "center",
  flexDirection: "column",
  flexWrap: "wrap",
  justifyContent: "center",
  minBlockSize: "400px",
  children: /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsx(Pictogram, {
      name: "CelebrationSuccess"
    }), /*#__PURE__*/_jsx(H1, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.complete"
      })
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.youScored",
        options: {
          totalQuestions,
          correctAnswers
        }
      })
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "quiz-end-screen__retake-button",
      onClick: onRetakeClick,
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.retake"
      })
    })]
  })
});
export default QuizEndScreen;